module.exports = __webpack_public_path__ + "site-6f5a10e5cdcb00a52804036e2e31fd42.webmanifest";